module.exports = __webpack_public_path__ + "img/logo3.36860503.png";